import { configureStore } from '@reduxjs/toolkit';
import { productReducer as items } from '../../entities/product/model';
import { cartReducer as cart } from '../../entities/cart/model';
import { orderReducer as orders } from '../../entities/order/model';
import { inviteReducer as invites } from '../../entities/invite/model';
import notifications from './notifications';
import { companyReducer as companies } from '../../entities/company/model';
import { contactReducer as contacts } from '../../entities/contact/model';
import { legalEntityReducer as legalEntities } from '../../entities/legal-entity/model';
import { authReducer as auth } from '../../entities/auth/model';
import { priceReducer as prices } from '../../entities/price/model';
import { registrationReducer as registration } from '../../entities/registration/model';
import { userReducer as users } from '../../entities/user/model';
import { employeeReducer as employees } from '../../entities/employee/model';
import { deviceReducer as devices } from '../../entities/device/model';
import { issueReducer as issues } from '../../entities/issue/model';
import { ticketReducer as tickets } from '../../entities/ticket/model';
import { helpdeskSettingsReducer as helpdeskSettings } from '../../entities/helpdesk-settings/model';
import { joinRequestsReducer as joinRequests } from '../../entities/joinrequest/model';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { syncRememberMeUser } from '../../entities/auth/lib';

export const store = configureStore({
  reducer: {
    items,
    invites,
    notifications,
    registration,
    companies,
    contacts,
    legalEntities,
    auth,
    prices,
    cart,
    orders,
    users,
    employees,
    devices,
    issues,
    tickets,
    helpdeskSettings,
    joinRequests,
  },
});

let lastUserRef: unknown = store.getState().auth.user;
store.subscribe(() => {
  const currentUser = store.getState().auth.user;
  if (currentUser !== lastUserRef) {
    lastUserRef = currentUser;
    if (currentUser && (currentUser as any).id) {
      syncRememberMeUser(currentUser);
    }
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
